<div class="content">
  <ng-container *ngIf="streamline">
    <app-devices-dashboard></app-devices-dashboard>
  </ng-container>
  <ng-container *ngIf="!streamline">
    <app-deployments></app-deployments>
  </ng-container>
</div>